/* eslint-disable no-console */
import type { Logger } from './Logger';

import { loadSentry } from '@/domains/core/observability/loadSentry';

export default {
  error(error: Error) {
    if (process.env.NODE_ENV === 'production') {
      loadSentry()
        .then((Sentry) => {
          Sentry.captureException(error);
        })
        .catch((err) =>
          console.error('Cannot load Sentry in clientSideLogger:', err)
        );
    } else {
      console.error(error);
    }
  },
} as Logger;
